import { useContext, useEffect } from "react";
import { FormContext } from "common/components/Form/FormContext";
import { Nullable } from "common/types";

export const useValidate = (
  validate: ((value: any, rootRecord?: any) => Nullable<string>) | undefined,
  name: string,
): void => {
  const { addValidate, removeValidate } = useContext(FormContext);

  useEffect(() => {
    if (validate) addValidate(name, validate);

    return () => {
      if (validate) removeValidate(name);
    };
  }, []);
};
